module.exports = __webpack_public_path__ + "static/brotopia-d7faaf23628369f55dfccd7ee48c6c20.jpg";